import { render, staticRenderFns } from "./resource.vue?vue&type=template&id=a67f59ae&scoped=true&"
import script from "./resource.vue?vue&type=script&lang=ts&"
export * from "./resource.vue?vue&type=script&lang=ts&"
import style0 from "./resource.vue?vue&type=style&index=0&id=a67f59ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67f59ae",
  null
  
)

export default component.exports